import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import SalesList from '../../views/Sales/SalesList.js';

const SalesRoute = () => {
	return (
		<div>
			<Routes>
				<Route path="/sales" element={<SalesList />} />
				<Route path="/" element={<Navigate to="/sales" replace />} />
			</Routes>
		</div>
	);
};

export default SalesRoute;
